module.exports = __webpack_public_path__ + "static/media/html.112e2a65.png";